var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    {
      attrs: { "two-line": "" },
      on: {
        click: function ($event) {
          return _vm.showDetail(_vm.lavorazione)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "progress-bkg",
          class: { compact: _vm.compact },
          style: { width: _vm.lavorazione.progresso + "%" },
          attrs: { "data-test": _vm.iconClassByProgress(_vm.lavorazione) },
        },
        [_vm._v(" ")]
      ),
      _c(
        "span",
        { on: { click: _vm.toggleSelezioneLavorazione } },
        [
          !_vm.lavorazioneSelezionata
            ? _c(
                "v-list-item-avatar",
                [
                  _c(
                    "v-icon",
                    {
                      class: [
                        _vm.iconClassByProgress(_vm.lavorazione),
                        "lighten-1",
                        "white--text",
                      ],
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("statoLavorazioneIco")(_vm.lavorazione.stato)
                        )
                      ),
                    ]
                  ),
                ],
                1
              )
            : _c(
                "v-list-item-avatar",
                [
                  _c(
                    "v-avatar",
                    { attrs: { color: "error" } },
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v("mdi-done-outline"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _vm.compact
        ? _c(
            "v-list-item-content",
            [
              _c("v-list-item-title", [
                _c("strong", [
                  _vm._v(" " + _vm._s(_vm.lavorazione.codiceLAK) + " "),
                  _vm.lavorazione.firstCost == "S"
                    ? _c("span", [_vm._v("USA")])
                    : _vm._e(),
                ]),
                _vm._v(" Ordine N. "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.lavorazione.ordineNumero) +
                      " / " +
                      _vm._s(_vm.lavorazione.ordineLinea)
                  ),
                ]),
                _vm._v(" del "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm._f("formatDate")(_vm.lavorazione.dataOrdine))
                  ),
                ]),
                _vm._v(", Lotto: "),
                _c("strong", [_vm._v(_vm._s(_vm.lavorazione.lotto))]),
                _vm._v(", Consegna: "),
                _c("strong", [_vm._v(_vm._s(_vm.lavorazione.codiceConsegna))]),
              ]),
              _c("v-list-item-subtitle", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.lavorazione.campionario ? "CAMPIONARIO" : "PRODUZIONE"
                    )
                  ),
                ]),
                _vm._v(" Data scadenza: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm._f("formatDate")(_vm.lavorazione.dataConsegna))
                  ),
                ]),
                _vm._v(", Colore: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.lavorazione.colore &&
                        `${_vm.lavorazione.colore.codiceColore} ${_vm.lavorazione.colore.descrizione}`
                    )
                  ),
                ]),
                _vm._v(", Numero capi: "),
                _c("strong", [_vm._v(_vm._s(_vm.lavorazione.qtaTotale))]),
              ]),
              _vm.lavorazione.datiAggiuntivi &&
              _vm.lavorazione.datiAggiuntivi.length > 0
                ? _c(
                    "v-list-item-subtitle",
                    _vm._l(_vm.lavorazione.datiAggiuntivi, function (da, i) {
                      return da.value
                        ? _c("span", { key: da.name }, [
                            _vm._v(" " + _vm._s(da.displayName) + ": "),
                            da.metadataType == _vm.metadataType.Datetime
                              ? _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm._f("formatDate")(da.value))
                                  ),
                                ])
                              : _c("strong", [_vm._v(_vm._s(da.value))]),
                          ])
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e(),
              _vm.workflow
                ? _c("StatoWorkflow", {
                    attrs: { stato: _vm.lavorazione.stato },
                  })
                : _vm._e(),
            ],
            1
          )
        : _c(
            "v-list-item-content",
            [
              _c("v-list-item-title", [
                _c("strong", [
                  _vm._v(" " + _vm._s(_vm.lavorazione.codiceLAK) + " "),
                  _vm.lavorazione.firstCost == "S"
                    ? _c("span", [_vm._v("USA")])
                    : _vm._e(),
                ]),
                _vm._v(" Ordine N. "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.lavorazione.ordineNumero) +
                      " / " +
                      _vm._s(_vm.lavorazione.ordineLinea)
                  ),
                ]),
                _vm._v(" del "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm._f("formatDate")(_vm.lavorazione.dataOrdine))
                  ),
                ]),
                _vm._v(", Stagione: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.lavorazione.stagione &&
                        `${_vm.lavorazione.stagione.id} ${_vm.lavorazione.stagione.descrizione}`
                    )
                  ),
                ]),
                _vm._v(", "),
                _vm.lavorazione.lineaVendita
                  ? _c("span", [
                      _vm._v(" Linea vendita: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.lavorazione.lineaVendita &&
                              `${_vm.lavorazione.lineaVendita.id} ${_vm.lavorazione.lineaVendita.descrizione}`
                          )
                        ),
                      ]),
                      _vm._v(", "),
                    ])
                  : _vm._e(),
                _vm._v(" Fase: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.lavorazione.fase &&
                        `${_vm.lavorazione.fase.id} ${_vm.lavorazione.fase.descrizione}`
                    )
                  ),
                ]),
              ]),
              _c("v-list-item-subtitle", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.lavorazione.campionario ? "CAMPIONARIO" : "PRODUZIONE"
                    )
                  ),
                ]),
                _vm._v(" Lotto: "),
                _c("strong", [_vm._v(_vm._s(_vm.lavorazione.lotto))]),
                _vm._v(" Consegna: "),
                _c("strong", [_vm._v(_vm._s(_vm.lavorazione.codiceConsegna))]),
                _vm._v(" Data scadenza: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm._f("formatDate")(_vm.lavorazione.dataConsegna))
                  ),
                ]),
                _vm._v(", Modello: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.lavorazione.modello &&
                        `${_vm.lavorazione.modello.codiceParte} ${_vm.lavorazione.modello.descrizione}`
                    )
                  ),
                ]),
                _vm._v(", Colore: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.lavorazione.colore &&
                        `${_vm.lavorazione.colore.codiceColore} ${_vm.lavorazione.colore.descrizione}`
                    )
                  ),
                ]),
                _vm._v(", Numero capi: "),
                _c("strong", [_vm._v(_vm._s(_vm.lavorazione.qtaTotale))]),
              ]),
              _vm.lavorazione.datiAggiuntivi &&
              _vm.lavorazione.datiAggiuntivi.length > 0
                ? _c(
                    "v-list-item-subtitle",
                    _vm._l(_vm.lavorazione.datiAggiuntivi, function (da, i) {
                      return da.value
                        ? _c(
                            "v-chip",
                            {
                              key: da.name,
                              class: [
                                _vm.getChipColorByHashedString(da.name),
                                "lighten-3",
                              ],
                              staticStyle: {
                                "margin-right": "0.25rem",
                                "margin-bottom": "0.2rem",
                              },
                              attrs: { label: "", small: "" },
                            },
                            [
                              _vm._v(" " + _vm._s(da.displayName) + ": "),
                              da.metadataType == _vm.metadataType.Datetime
                                ? _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm._f("formatDate")(da.value))
                                    ),
                                  ])
                                : _c("strong", [_vm._v(_vm._s(da.value))]),
                            ]
                          )
                        : _vm._e()
                    }),
                    1
                  )
                : _vm._e(),
              _vm.workflow
                ? _c("StatoWorkflow", {
                    attrs: { stato: _vm.lavorazione.stato },
                  })
                : _vm._e(),
            ],
            1
          ),
      _c(
        "v-list-item-action",
        [
          _vm.lavorazione.note && _vm.lavorazione.note.length > 0
            ? _c(
                "v-tooltip",
                { attrs: { left: "" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "ico-stato",
                      attrs: {
                        slot: "activator",
                        color: "yellow darken-1",
                        dark: "",
                      },
                      slot: "activator",
                    },
                    [_vm._v("mdi-note")]
                  ),
                  _c("span", [_vm._v(_vm._s(_vm.lavorazione.note))]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }